import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./home.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUser, FaLock, FaEyeSlash, FaEye } from "react-icons/fa";
import "../landingPage/landingPage.css";
import Modal from "react-bootstrap/Modal";
import { getFirebaseErrorMessage } from "../getFirebaseErrorMessage";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import init from "../../firebase";
import { useUserAuth } from "../../context/UserAuthContext";
import Swal from "sweetalert2";
import axios from "axios";

const Home = () => {
  const { language } = useUserAuth();
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const auth = init.auth;
  let navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [hide, setHide] = useState(false);
  const [email, setEmail] = useState("");
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const formHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setData({ ...data, [name]: value });
  };

  const Icon = () => {
    return hide ? <FaEye className="icon" /> : <FaEyeSlash className="icon" />;
  };

  const loginHandler = async (e) => {
    e.preventDefault();
    const { email, password } = data;

    if (!email) {
      Swal.fire({
        title: "Email field is required!",
        icon: "error",
      });
      return;
    }

    if (!password) {
      Swal.fire({
        title: "Password field is required!",
        icon: "error",
      });
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const token = await user.getIdToken(true);

      const res = await axios.get(`${base_url}/api/v1/manager/check-manager`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        toast.success("Login successful!");
        localStorage.setItem("token", token);
        navigate("/dashboard/dash_board");
      } else {
        await auth.signOut();
        Swal.fire({
          title: "Access denied!",
          text: "You are not a manager",
          icon: "error",
        });
      }
    } catch (err) {
      console.log("Login error:", err);
      await auth.signOut();
      if (err.response) {
        Swal.fire({
          title: err.response.data.message || "Login failed",
          icon: "error",
        });
      } else {
        const msg = getFirebaseErrorMessage(err.code);
        Swal.fire({ title: msg, icon: "error" });
      }
      setData({ ...data, password: "" });
    }
  };

  const resetPasswordHandler = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter email");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      handleClose();
      setEmail("");
      toast.success("Reset link sent to your email!");
    } catch (err) {
      const msg = getFirebaseErrorMessage(err.code);
      Swal.fire({
        title: msg,
        icon: "error",
        cancelButtonText: "Close",
        showCancelButton: true,
        showConfirmButton: false,
      });
    }
  };

  return (
    <>
      <div className="login__screen">
        <div className="login-container">
          <div className="login-card">
            {/* Logo Section */}
            <div className="logo-wrapper">
              <div className="logo-circle">
               <img src="logo-w.png" style={{objectFit:'contain',width:'30px'}}/>
              </div>
              <h2 className="logo-text">Manager Portal</h2>
            </div>

            {/* <h3 className="login-heading">
              {language === "en" ? "Manager Login" : "लॉगिन करें"}
            </h3> */}

            <form onSubmit={loginHandler}>
              <div className="input-group">
                <div className="input-icon">
                  <FaUser />
                </div>
                <input
                  type="text"
                  placeholder="Email Address"
                  onChange={formHandler}
                  name="email"
                  value={data.email}
                  className="login-input"
                />
              </div>

              <div className="input-group">
                <div className="input-icon">
                  <FaLock />
                </div>
                <input
                  type={hide ? "text" : "password"}
                  placeholder="Password"
                  onChange={formHandler}
                  name="password"
                  value={data.password}
                  autoComplete="off"
                  className="login-input"
                />
                <div className="password-toggle" onClick={() => setHide(!hide)}>
                  <Icon />
                </div>
              </div>

              <p className="forgot-password" onClick={handleShow}>
                Forgot Password?
              </p>

              <button type="submit" className="login-button">
                {language === "en" ? "Sign In" : "साइन इन करें"}
              </button>
            </form>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered backdrop="static" className="forgot-modal">
        <Modal.Header closeButton>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="modal-text">Enter your registered email address and we'll send you a link to reset your password.</p>
          <input
            type="email"
            className="modal-input"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="modal-btn-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button className="modal-btn-submit" onClick={resetPasswordHandler}>
            Send Reset Link
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Home;